import _ from 'lodash';
import { api } from "../api/apiCore";
import { cache, invalidateByPrefix } from '../utils/apiCache';
import { isDeviceTimezoneMode, convertRangeToDateOnly } from '../component/helpers/timeDisplaySettings';

const DEVICES_TTL = 15 * 60 * 1000;

export function getDevicesEventUpdates(user_role, company_name=null, partner_name=null) {
	let url
	switch(user_role) {
	case 'system_admin':
		url = `/system_admin/partner/${partner_name}/companies/${company_name}/devices/eventupdates`
		break
	case 'customer_service':
		url = `/customer_service/partner/${partner_name}/companies/${company_name}/devices/eventupdates`
		break
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${company_name}/devices/eventupdates`
		break
	case 'partner_view':
		url = `/partner_view/companies/${company_name}/devices/eventupdates`
		break
	case 'sales_demo':
		url = `/sales_demo/partner/${partner_name}/companies/${company_name}/devices/eventupdates`
		break
	default:
		url = `/devices/eventupdates`
		break
	}

	return api.get(url)
}

export function getDevicesLastgps(data) {
	const { user_role, company_name, partner_name, inactive } = data
	let url

	switch(user_role) {
		case 'system_admin':
			// url = `/system_admin/companies/${company_name}/devices/lastevent`;
			url = `/system_admin/partner/${partner_name}/companies/${company_name}/devices/lastevent`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${partner_name}/companies/${company_name}/devices/lastevent`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${company_name}/devices/lastevent`;
			break;
		case 'partner_view':
			url = `/partner_view/companies/${company_name}/devices/lastevent`;
			break;
		case 'sales_demo':
			url = `/sales_demo/partner/${partner_name}/companies/${company_name}/devices/lastevent`;
			break;
		default:
			url = `/devices/lastevent`;
			break;
	}

	if (inactive) {
		url += '?inactive=' + inactive
	}

	return api.get(url)
}

export function getDevicesLive(data) {
	console.log('!gettDevicesLive data: ', data)

	const url = `/live/${data.device_id}/${data.channel}?timestamp=${new Date().getTime()+ Math.random()}`;

	return api.get(url)
}

export function stopDevicesLive(data) {
	console.log('!stopDevicesLive', data)

	let url;
	switch(data.user_role) {
	case 'system_admin':
		url = `/system_admin/live/stop/${data.device_id}/${data.channel}`;
		break;
	case 'customer_service':
		url = `/customer_service/live/stop/${data.device_id}/${data.channel}`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/live/stop/${data.device_id}/${data.channel}`;
		break;
	default:
		url = `/live/stop/${data.device_id}/${data.channel}`;
		break;
	}

	return api.get(url)
}

export function getDevicesMetadata(data) {
	const url = `/devices/metadata?ids=${data.device_id}&start_ts=${data.start_ts}&end_ts=${data.end_ts}`;

	return api.get(url)
}

export function getMissingGps(data) {
	let params = '';
	for (const key in data) {
		params += `${(!params ? '?' : '&')}${key}=${data[key]}`
	}
	const url = `/devices/gps${params}`;

	return api.get(url);
}

/* Get last known GPS or Alert location */
export function getDevicesMetadataLastKnown(data) {
	const url = `/devices/metadata/last24?ids=${data.device_ids}`;

	return api.get(url)
}

export function createDevicesCustomer(data) {
	console.log('!createDevicesCustomer action data: ', data);
	let url;
	switch (data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/devices`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/devices`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/devices`;
			break;
		default:
			break;
	}

	const form = new FormData();
	if (data.snlist) {
		form.append('snlist', data.snlist);
	}
	if (data.number) {
		form.append('number', data.number);
	}

	return api.putForm(url, form).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function getAllDevices(userRole, companyName = null, partnerName = null, fields = null, version = null, assetFields = null) {
	let url;
	const attr = [];
	switch (userRole) {
	case 'system_admin':
		url = `/system_admin/partner/${partnerName}/companies/${companyName}/devices`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${partnerName}/companies/${companyName}/devices`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${companyName}/devices`;
		break;
	case 'partner_view':
		url = `/partner_view/companies/${companyName}/devices`;
		break;
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'user':
	case 'storage_manager':
	case 'storage_user':
	case 'custom_user':
		attr.push(`page_number=1`);
		attr.push(`page_size=10000`);
		url = `/devices/list`;
		break;
	case 'installer':
		url = `/installer/companies/${companyName}/devices`;
		break;
	case 'sales_demo':
		url = `/sales_demo/partner/${partnerName}/companies/${companyName}/devices`;
		break;
	default:
		break;
	}

	if (assetFields) {
		attr.push(`include_data=${assetFields}`)
	}

	if (fields) {
		attr.push(`fields=${fields}`)
	}

	if (version) {
		attr.push('version=true')
	}

	if (attr.length > 0) {
		url += `?${attr.join('&')}`
	}

	const cacheKey = `devices:all:${userRole}:${companyName || ''}:${partnerName || ''}:${fields || ''}:${version ? '1' : '0'}:${assetFields || ''}`;
	return cache(cacheKey, () => api.get(url), DEVICES_TTL);
}

export function getDevicesList(company_id, params = null) {
	const cacheKey = `devices:${company_id}:${params || ''}`;
	let url = `/companies/${company_id}/devices/list`;
	if (params) url += '?include_data=' + params;
	return cache(cacheKey, () => api.get(url), DEVICES_TTL);
}

export function getDevicesDriverID(company_id) {
	const url = `/driver/devices/cardreader?company_id=${company_id}`

	return api.get(url)
}

export function toggleDevicesDriverID(data, company_id) {
	const url = `/driver/devices/cardreader`

	let form = new FormData()
	form.append('enabled', data.enabled)
	form.append('devices', data.devices)
	form.append('company_id', company_id)

	return api.postForm(url, form).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function getFleetDevices() {
	const url = `/devices/list`;

	return api.get(url)
}

export function getDeviceById(data) {
	console.log('getDeviceById action data:', data);

	let url;
	switch (data.userRole) {
		case 'system_admin':
			url = `/system_admin/devices/${data.deviceId}`;
			break;
		case 'customer_service':
			url = `/customer_service/devices/${data.deviceId}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/devices/${data.deviceId}`;
			break;
		case 'installer':
			url = `/provisioning/devices/${data.deviceId}`;
			break;
		default:
			url = `/devices/${data.deviceId}`;
			break;
	}

	const attr = []
	const includeData = []

	if (_.has(data, 'geotab')) {
		attr.push(`geotab=${data.geotab}`)
	}

	if (_.has(data, 'modem')) {
		attr.push(`modem=${data.modem}`)
	}

	if (_.has(data, 'externalSrv')) {
		attr.push(`external_srv=${data.externalSrv}`)
	}

	if (_.has(data, 'includeData')) {
		attr.push(`include_data=${data.includeData}`)
	}

	if (attr.length > 0) {
		url += `?${attr.join('&')}`
	}

	return api.get(url)
}


export function updateDevice(data, user_role, company, callback) {
	let user_email = data.devicesUsers ? (data.devicesUsers.length < 1 ? 'none' :  data.devicesUsers ) : ''
	let url

	switch (user_role) {
		case 'system_admin':
			url = `/system_admin/devices/${data.deviceId}`;
			break;
		case 'customer_service':
			url = `/customer_service/devices/${data.deviceId}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/devices/${data.deviceId}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'installer':
		case 'storage_manager':
		case 'custom_user':
			url = `/devices/${data.deviceId}`;
			break;
		default:
			break;
	}

	let form = new FormData()
	data.data.vehicle_icon ? form.append('vehicle_icon', data.data.vehicle_icon) : ''
	data.data.vehicle_name ? form.append('vehicle_name', data.data.vehicle_name) : ''
	data.data.contract_id ? form.append('contract_id', data.data.contract_id) : ''
	data.data.data_limit ? form.append('data_limit', data.data.data_limit) : ''
	data.data.timezone ? form.append('timezone', data.data.timezone) : ''
	data.data.parking_duration ? form.append('parking_duration', data.data.parking_duration) : ''

	_.has(data.data, 'user_email') ? form.append('user_email', data.data.user_email) : false
	user_email ? form.append('user_email', user_email) : false
	_.has(data.data, 'driver_name') ? form.append('driver_name', data.data.driver_name) : false
	_.has(data.data, 'driver_id') ? form.append('driver_id', data.data.driver_id) : false
	_.has(data.data, 'active') ? form.append('active', data.data.active) : false
	_.has(data.data, 'flood_blocked') ? form.append('flood_blocked', data.data.flood_blocked) : false
	_.has(data.data, 'driver_recognition') ? form.append('driver_recognition', data.data.driver_recognition) : false
	_.has(data.data, 'cardreader') ? form.append('cardreader', data.data.cardreader) : false
	_.has(data.data, 'canbus') ? form.append('canbus', data.data.canbus) : false

	_.has(data.data, 'adas_units') ? form.append('adas_units', data.data.adas_units) : ''
	_.has(data.data, 'adas_vehicle_hood_len') ? form.append('adas_vehicle_hood_len', data.data.adas_vehicle_hood_len) : ''
	_.has(data.data, 'adas_camera_height') ? form.append('adas_camera_height', data.data.adas_camera_height) : ''
	_.has(data.data, 'adas_vehicle_width') ? form.append('adas_vehicle_width', data.data.adas_vehicle_width) : ''
	_.has(data.data, 'adas_camera_offset') ? form.append('adas_camera_offset', data.data.adas_camera_offset) : ''
	// _.has(data.data, 'data_threshold_pct') ? form.append('data_threshold_pct', data.data.data_threshold_pct) : ''
	// _.has(data.data, 'data_threshold_type') ? form.append('data_threshold_type', data.data.data_threshold_type) : ''
	_.has(data.data, 'disable_live_stream') ? form.append('disable_live_stream', data.data.disable_live_stream) : ''
	_.has(data.data, 'can_log_upload') ? form.append('can_log_upload', data.data.can_log_upload) : ''
	_.has(data.data, 'ignition_switch_only') ? form.append('ignition_switch_only', data.data.ignition_switch_only) : ''
	// _.has(data.data, 'sleep_mode_enabled') ? form.append('sleep_mode_enabled', data.data.sleep_mode_enabled) : ''
	_.has(data.data, 'vehicle_icon_size') ? form.append('vehicle_icon_size', data.data.vehicle_icon_size) : ''

	api.postForm(url, form)
		.then((res, err)=>{
			invalidateByPrefix('devices:');
			if (data.data.groups) {
				if (!_.isEqual(_.sortBy(data.data.groups), _.sortBy(data.initialData.groups))) {

					//* Was removed groups
					const arr_remove = _.difference(data.initialData.groups, data.data.groups)
					let settings_remove_url;

					//* Was added groups
					const arr_add = _.difference(data.data.groups, data.initialData.groups)
					let settings_add_url;

					const count = arr_remove.length + arr_add.length

					let i = 0

					arr_remove.forEach(function(item) {

						switch(user_role) {
						case 'system_admin':
							settings_remove_url = `/system_admin/partner/${company.partner}/companies/${company.name}/groups/${item}/devices/${data.deviceId}`;
							break;
						case 'customer_service':
							settings_remove_url = `/customer_service/partner/${company.partner}/companies/${company.name}/groups/${item}/devices/${data.deviceId}`;
							break;
						case 'partner':
						case 'custom_partner':
							settings_remove_url = `/partners/companies/${company.name}/groups/${item}/devices/${data.deviceId}`;
							break;
						case 'fleet_maintainer':
						case 'fleet_manager':
						case 'storage_manager':
						case 'custom_user':
							settings_remove_url = `/groups/${item}/devices/${data.deviceId}`;
							break;
						}

						api.delete(settings_remove_url).then((res, err)=> {
							i++;
							if (i >= count) {
								if (typeof callback === 'function') {
									return callback(null, {result:'ok'})
								}
							}

						})
							.catch((error)=>{
								if (typeof callback === 'function') {
									return callback(error, null)
								}
							})
					})

					arr_add.forEach(function(item) {
						switch(user_role) {
						case 'system_admin':
							settings_add_url = `/system_admin/partner/${company.partner}/companies/${company.name}/groups/${item}/devices/${data.deviceId}`
							break
						case 'customer_service':
							settings_add_url = `/customer_service/partner/${company.partner}/companies/${company.name}/groups/${item}/devices/${data.deviceId}`
							break
						case 'partner':
						case 'custom_partner':
							settings_add_url = `/partners/companies/${company.name}/groups/${item}/devices/${data.deviceId}`
							break
						case 'fleet_maintainer':
						case 'fleet_manager':
						case 'storage_manager':
						case 'custom_user':
							settings_add_url = `/groups/${item}/devices/${data.deviceId}`
							break
						}


						api.putForm(settings_add_url).then((res, err)=>{
							i++
							if (i >= count) {
								if (typeof callback === 'function') {
									return callback(null, {result:'ok'})
								}
							}
						})
							.catch((error)=>{
								if (typeof callback === 'function') {
									return callback(error, null)
								}
							})
					});

				}
				else {
					if (typeof callback === 'function') {
						return callback(null, {result:'ok'})
					}
				}
			}
			else {
				if (typeof callback === 'function') {
					return callback(null, {result:'ok'})
				}
			}

		})
		.catch((error)=>{
			if (typeof callback === 'function') {
				return callback(error, null)
			}
		})
}

export function deleteDeviceCustomer(data) {
	let url;
	switch(data.user_role) {
	case 'system_admin':
		url = `/system_admin/devices/${data.device_id}`;
		break;
	case 'customer_service':
		url = `/customer_service/devices/${data.device_id}`;
		break;
	}

	return api.delete(url).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function deleteDatabaseDevice(data) {
	let url = `/devices/database/${data.device_id}`;

	return api.delete(url).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function getDevicesModems(data){
	let url;
	switch(data.user_role) {
	case 'system_admin':
		url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/devices/modems`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/devices/modems`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${data.company_name}/devices/modems`;
		break;
	}

	return api.get(url);
}

export function getDeviceAddress(data){
	let url =`/address?lat=${data.lat}&lng=${data.lng}`;

	return api.get(url);
}

export function getDeviceRoutesDates(deviceId, params) {
	const queryParams = new URLSearchParams(params).toString();
	const url = `/devices/${deviceId}/routes/dates?${queryParams}`;

	return api.get(url);
}

export function getDeviceRoutes(deviceId, params) {
	const queryParams = new URLSearchParams(params).toString();
	const url = `/devices/${deviceId}/routes?${queryParams}`;

	return api.get(url);
}

export function getDevicesMigrationList (data) {
	const url = `/companies/${data.company_id}/devices/migration`;

	return api.get(url)
}

export function getCompanyDevicesList (data) {
	return getDevicesList(data.company_id);
}

export function deviceAcknowledgeClear(data) {
	const { device_id, ...rest } = data;
	let url = `/devices/${device_id}/camera_health_error/acknowledge_clear`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form);
}

export function deviceSilenceErrors(data) {
	const { device_id, ...rest } = data;
	let url = `/devices/${device_id}`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function deviceWakeUp(data) {
	let url = `/devices/${data.device_id}/wakeup`;

	return api.postForm(url);
}

export function upgradeDeviceFirmware(data) {
	const { device_id, ...rest } = data;
	let url = `/devices/firmware/package?ids=${device_id}`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form);
}

export function saveDeviceCalibration(data) {
	const { device_id, ...rest } = data;
	let url = `/devices/${device_id}`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function addDeviceInstallReport(data) {
	const { device_id, ...rest } = data;
	let url = `/devices/${device_id}/install_report`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form);
}

export function deviceFirmwarePackage(data) {
	const { device_id, ...rest } = data;
	let url = `/devices/firmware/package?ids=${device_id}`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form);
}

export function deviceClearChannelStatus(device_id, data) {
	let url = `/devices/${device_id}/clear_channel_status`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form);
}

export function deviceReplace(data) {
	const { device_id, ...rest } = data;
	let url = `/devices/${device_id}/replace`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function deviceMigrate(id, data) {
	let url = `/companies/${id}/devices/migration`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form).then((res) => {
		invalidateByPrefix('devices:');
		return res;
	});
}

export function deviceRestart(data) {
	const { device_id } = data;
	const url = `/device/${device_id}/restart`;

	return api.get(url);
}

export function getDeviceRecordingLogs(data) {
	const { device_ids, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}
	const url = `/devices/${device_ids}/recording_log${params}`;

	return api.get(url);
}

export function getDeviceAvailableVideo(data) {
	const { device_id, allowDeviceTz, ...rest } = data;
	convertRangeToDateOnly(rest, 'start_time', 'end_time', allowDeviceTz)

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}
	const url = `/devices/${device_id}/availablevideo${params}`;

	return api.get(url);
}

export function getAvailableVideoDates(data) {
	const { deviceId, allowDeviceTz, ...rest } = data;
	if (allowDeviceTz && isDeviceTimezoneMode()) {
		rest.timezone = 'device'
	}

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}
	const url = `/devices/${deviceId}/availablevideo/dates${params}`;

	return api.get(url);
}

export function getDeviceCameraHealthError(data) {
	const { device_id } = data;

	const url = `/devices/${device_id}/camera_health_error`;

	return api.get(url);
}

export function getDeviceMetadataHistory(data) {
	const { device_id, user_role, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}
	const url = `/${user_role}/devices/${device_id}/metadata${params}`;

	return api.get(url);
}

export function getDeviceMetadata(data) {
	const { device_id, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}
	const url = `/devices/${device_id}/metadata${params}`;

	return api.get(url);
}

export function getRouteSnapshots(data) {
	const { route_id } = data;
	const url = `/devices/routes/${route_id}/snapshots`;

	return api.get(url);
}

export function getDeviceConfigHistory(data) {
	const { device_id, ...rest } = data;

	let params = '';
	for (const key in rest) {
		params += `${(!params ? '?' : '&')}${key}=${rest[key]}`
	}
	const url = `/devices/${device_id}/config_history${params}`;

	return api.get(url);
}

export function getConfigHistoryFile(data) {
	const { id } = data;

	const url = `/devices/config_history/${id}/file`;

	return api.get(url);
}

export function getDevicesGeneralStatus(data) {
	let params = '';
	for (const key in data) {
		params += `${(!params ? '?' : '&')}${key}=${data[key]}`
	}
	const url = `/devices/general_status${params}`;

	return api.get(url);
}

export function getReplaceHistory(data) {
	const { device_id } = data;

	const url = `/devices/${device_id}/replace_history`;

	return api.get(url);
}

export function getDeviceInstallReports(data) {
	const { deviceId } = data;

	const url = `/device/${deviceId}/install/report`;

	return api.get(url);
}

export function getInstallReport(data) {
	const { reportId } = data;

	const url = `/device/install/report/${reportId}`;

	return api.get(url);
}

export function downloadDeviceInstallReport(url) {
	return api.get(url, {
		responseType: "blob",
	});
}
